import { TicketResponses } from 'src/types/elements.type';
import { ApprovalStatus } from 'src/types/helpdesk/ticket.type';
import { ILeavePackage, LeavePackageAdd } from 'src/types/hr_ticket/leavePackage.type';
import { PagedList } from 'src/types/pagedList.type';
import { ITicketParams } from 'src/types/params.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/leave-packages';

export const getLeavePackages = async (
  ticketStatusId: number | undefined,
  searchCondition: string | undefined,
  page: number,
  pageSize: number,
  fromDate?: Date,
  toDate?: Date,
  orderBy?: string
) => {
  return await http.get<PagedList<ILeavePackage>>(`${controller}`, {
    params: {
      ticketStatusId,
      searchCondition,
      fromDate,
      toDate,
      page,
      pageSize,
      orderBy
    }
  });
};

export const getLeavePackagesApproval = async (params: ITicketParams) => {
  return await http.get<PagedList<ILeavePackage>>(`${controller}/waiting-approval`, {
    params: params
  });
};

export const getLeavePackage = async (id: string | number) => {
  return http.get<ILeavePackage>(`${controller}/${id}`);
};

export const addLeavePackage = async (leavePackage: LeavePackageAdd) => {
  return http.post<ILeavePackage>(controller, leavePackage);
};

export const cancelLeavePackage = async (id: string | number) => {
  await http.put(`${controller}/${id}/cancel`);
};

export const approvalLeavePackage = async (
  ticketResponses: TicketResponses[],
  approvalStatus: ApprovalStatus,
  note: string
) =>
  await http.put(`${controller}/approval?id=${ticketResponses[0].ticketId}`, {
    step: ticketResponses[0].step,
    approvalStatus,
    note: note ? note : ''
  });

export const cancelApprovalLeavePackage = async (id: string, step: number) =>
  await http.put(`${controller}/${id}/cancel-approval`, { step });
